import React, { useState, useEffect } from "react";
import { useClient } from "./Provider";
import { useCompany } from "../Companies/Provider";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { createYupSchema } from "../../utilities/yupSchemaCreator";
import * as Yup from "yup";
import fields from "./fields";
// material ui
import {
  Box,
  Typography,
  TextField,
  Switch,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Button,
  useTheme,
  Card,
  Alert,
} from "@mui/material";
import styled from "styled-components";
// utilities
import { handleResponse } from "../../utilities/functions";
// components
import ErrorsList from "../../ui/ErrorsList";

//css styled
const GridGroup = styled.div`
  max-width: 1210px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 2px;
  row-gap: 0;
  padding: 20px;
  margin-bottom: 20px;
`;

const ButtonWrapper = styled.div`
  margin-bottom: 50px;
  button {
    float: right;
    margin-left: 20px;
  }
`;
export const switchStyle = {
  ".css-ahj2mt-MuiTypography-root": {
    fontSize: "14px",
  },
  ".css-julti5-MuiSwitch-root": {
    height: "55px",
    width: "85px",
  },
  ".css-jsexje-MuiSwitch-thumb": {
    width: "26px",
    height: "26px",
  },
  ".css-1yjjitx-MuiSwitch-track": {
    borderRadius: "20px",
  },
  ".css-5ryogn-MuiButtonBase-root-MuiSwitch-switchBase": {
    top: "5px",
    left: "4px",
  },
  ".css-5ryogn-MuiButtonBase-root-MuiSwitch-switchBase.Mui-checked": {
    color: "white",
    left: "16px",
  },
  ".css-5ryogn-MuiButtonBase-root-MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track":
    {
      backgroundColor: "#268B61",
      opacity: "1",
    },
};

const yupSchema = fields.reduce(createYupSchema, {
    clientName: Yup.string(),
  });
  const formSchema = Yup.object().shape({
    ...yupSchema,
    isActive: Yup.boolean(),
  });

  const FormClient = ({ client, handleSuccess, setClientName }) => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
    defaultValues: {
      isActive: client ? client["isActive"] : true,
    },
  });
  const navigate = useNavigate();
  let theme = useTheme();
  let params = useParams();

  const id = params.id;
  const [error, setError] = useState(null);
  const { create, edit } = useClient();
  const {
    state: { selected: company },
    fetchOne: fetchCompany,
  } = useCompany();

  useEffect(() => {
    if (!client) fetchCompany(id);
  }, [id, fetchCompany, client]);

  const onSubmit = async (values) => {
    if (!client) values.companyId = id;
    else values.companyId = client.companyId;
    try {
      if (client) await edit(client.id, values);
      else {
        await create(values);
        setClientName(values.clientName);
        reset();
      }
      handleSuccess();
    } catch (e) {
      window.scrollTo(0, 0);

      if (e.status === 400) setError(e.errors);
      if (e.status === 409) setError({ title: e.errors.message });
      handleResponse(e.errors.status);
    }
  };
  // Fields functions
  const onChange = (v, name) => {
    setValue(name ?? v.target.name, v.target.value);
  };
  return (
    <>
      <Box>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Card
            sx={{
              p: theme.dimensions.padding,
              mt: theme.dimensions.mt,
              mb: theme.dimensions.mb,
            }}>
            <Typography variant="Poster" component="h4" gutterBottom>
              Client Details
            </Typography>
            {error && (
              <Alert severity="error">
                <ErrorsList error={error} />
              </Alert>
            )}
            <GridGroup>
              {fields.map((f, i) => {
                if (f.viewOnly) return null;
                const inputProps = { ...f.inputProps };

                if (i === 0) inputProps.autoFocus = true;
                inputProps.type = f.type;
                return (
                  <Box key={i}>
                    {f.switch ? (
                      <Box>
                        <FormGroup>
                          <FormLabel
                            component="legend"
                            sx={{
                              mt: theme.dimensions.mt,
                            }}>
                            {f.label}
                          </FormLabel>
                          <FormControlLabel
                            control={
                              <Switch
                                color="success"
                                defaultChecked={
                                  client ? client[f?.name] : true
                                }
                              />
                            }
                            {...register(f.name)}
                            label="Active"
                          />
                        </FormGroup>
                      </Box>
                    ) : (
                      <TextField
                        label={f.label}
                        name={f.name}
                        error={f.required && !!errors[f.name]}
                        helperText={errors[f.name]?.message}
                        select={f.select}
                        size="small"
                        className={f.class}
                        type={f.type}
                        fullWidth
                        value={f.select && undefined}
                        defaultValue={
                          client && client[f?.name] ? client[f?.name] : ""
                        }
                        onChange={(v) => onChange(v, f.name)}
                        disabled={f.disabled}
                        required={f.required}
                        sx={{
                          width: theme.dimensions.width,
                          mt: theme.dimensions.mt,
                          mb: theme.dimensions.mb,
                        }}
                        inputProps={{
                          ...register(f.name),
                        }}
                      />
                    )}
                  </Box>
                );
              })}
            </GridGroup>
            {/* Buttons */}
            <ButtonWrapper>
              <Button
                variant="contained"
                type="submit"
                sx={{
                  backgroundColor: theme.color.blackBackground,
                  ml: theme.dimensions.ml,
                  "&:hover": { background: `${theme.color.black}` },
                }}>
                {client ? "Save" : "Add Client"}
              </Button>
              <Button
                variant="contained"
                onClick={() => navigate(-1)}
                sx={{
                  backgroundColor: theme.color.grayBackground,
                  color: theme.color.dark,
                  "&:hover": { background: `${theme.color.gray50}` },
                }}>
                Discard
              </Button>
            </ButtonWrapper>
          </Card>
        </form>
      </Box>
    </>
  );
};

export default React.memo(FormClient);